import React from "react";
import chinaFlag from "../../images/Flag_of_the_People's_Republic_of_China.svg";
const Footer: React.FC = () => {
  const hrefGen = (href: string) => {
    return `https://www.thermofisher.cn/${"cn"}/${"zh"}/home/global/${href}.html`;
  };

  return (
    <div
      className={"pageContentContainer"}
      style={{
        display: "flex",
        flexWrap: "wrap",
        background: "#fff",
        justifyContent: "space-between",
        paddingTop: "8px",
        paddingBottom: "25px",
        fontSize: "14px",
      }}
    >
      <div style={{ paddingTop: "8px" }}>
        <div>
          <a
            className="App-link"
            target="blank"
            href={hrefGen("terms-and-conditions")}
          >
            {/* {f("TERMS")} */}
            {'服务条款'}
          </a>
          <span style={{ color: "#e5e5e5" }}>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <a
            className="App-link"
            target="blank"
            href={hrefGen("privacy-policy")}
          >
            {/* {f("PRIVACY")} */}
            {'隐私政策'}
          </a>
        </div>
      </div>
      <div style={{ paddingTop: "8px" }}>
        <img
          alt=""
          height={11}
          width={16}
          src={chinaFlag}
        ></img>
        &nbsp;China | 中国
      </div>
    </div>
  );
};

export default Footer;
